var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-item-list"},_vm._l((_vm.faqList),function(item){return _c('FaqAccordeon',{key:item.id,ref:"faqList",refInFor:true,attrs:{"title":item.title,"answer":item.answer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }